import createCachedSelector from 're-reselect';
import { createSelector } from '@reduxjs/toolkit';

import type { ReduxState } from 'app/redux/types';

import { SlotType } from 'app/lib/betting/betting-entities';
import { SportId } from 'app/lib/betting/constants';
import { sortIdsByPriority } from 'app/lib/sortByPriorityImmutableData';

import { matches, sportIds, sports } from './entities';

export const selectInterestingMatches = (state: ReduxState) => {
  return state.interestingMatches;
};

export const selectInterestingMatchesById = (state: ReduxState) => {
  return selectInterestingMatches(state).get('entities').matches.byId;
};

export const hasLiveMatches = (state: ReduxState) => {
  return selectInterestingMatches(state).get('hasLiveMatches');
};

export const onlyLiveMatches = (state: ReduxState) => {
  return selectInterestingMatches(state).get('showLiveMatches');
};

export const selectSomeLiveMatch = createCachedSelector(
  (state: ReduxState, sportId: SportId) => sports(state).get(sportId)?.matchIds,
  matches,
  (matchIds, matches) => {
    if (!matchIds) {
      return false;
    }

    return [...matchIds].some((id) => {
      const match = matches.get(id);

      return match?.slotType === SlotType.LIVE;
    });
  },
)((_state: ReduxState, sportId) => sportId);

export const selectSortedSportIds = createSelector(
  sports,
  sportIds,
  (sports, sportIds) => {
    return sortIdsByPriority(sportIds, sports);
  },
);
